<div
  class="game-card"
  [ngClass]="{ 'is-mobile': isMobile }"
  [ngStyle]="{ 'background-image': 'url(' + game.imagePath + ')' }"
>
  <div class="game-information">
    <h3 class="game-title">
      {{ game.gameName }}
    </h3>

    <lynx-button
      class="game-link"
      (clickAction)="launchGame(game)"
      [text]="'Game.Button.Title'"
    >
    </lynx-button>
  </div>
  <div class="mobile-link" (click)="launchGame(game)"></div>
</div>
